import { useSelector } from 'react-redux';
import { selectOrderVolumeProfileStreamRequestBySymbolStreamedData } from 'widgets/orderVolumeProfile/store/data/streamSlice.ts';
import { usePortfolioSelection } from 'portfolio/store/hooks.ts';
import { useMemo } from 'react';
import { getStreamKey } from 'widgets/orderVolumeProfile/store/data/request-utils.ts';
import { useOrderVolumeProfileComponentSlice } from 'widgets/orderVolumeProfile/store/component/componentSlice.ts';
import { useWidgetContext } from 'widgets/WidgetContext.tsx';
import cloneDeep from 'lodash/cloneDeep';
import { useOrderVolumeProfileConfigSlice } from 'widgets/orderVolumeProfile/store/configuration/configSlice.ts';

function useOrderVolumeProfileWidgetStreamKey() {
    const { config } = useOrderVolumeProfileConfigSlice();
    const { component } = useOrderVolumeProfileComponentSlice();
    const { selectedOrder, selectedSymbol, symbology } =
        usePortfolioSelection();

    return useMemo(() => {
        if (!selectedOrder) {
            return undefined;
        }
        return getStreamKey(
            selectedSymbol!,
            symbology,
            selectedOrder,
            config,
            component
        );
    }, [component, config, selectedOrder, selectedSymbol, symbology]);
}

export function useOrderVolumeProfileWidgetStreamedData() {
    const streamState = useSelector(
        selectOrderVolumeProfileStreamRequestBySymbolStreamedData
    );
    const streamKey = useOrderVolumeProfileWidgetStreamKey();
    const { widgetKey } = useWidgetContext();

    return useMemo(() => {
        const data = streamKey ? streamState[streamKey] : undefined;
        // eslint-disable-next-line no-console
        console.log('useOrderVolumeProfileWidgetStreamedData returning', {
            streamKey,
            streamState: cloneDeep(streamState),
            data: cloneDeep(data),
            widgetKey,
        });
        return data;
    }, [streamState, streamKey, widgetKey]);
}
